// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DespesasCategorias_CarregaCategoriasInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/despesas_categorias/carrega_categorias
 *
 * Fetches all expense categories. No body required.
 */
import { registerContract } from './validate'

export interface DespesasCategorias_CarregaCategoriasInput {}

registerContract('DespesasCategorias_CarregaCategoriasInput', {})
